import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import EsSEO from '@/components/seo/EsSEO';

const SpanishNotFound = () => {
  // Belt-and-suspenders synchronous noindex injection (see /pages/NotFound.jsx
  // for the rationale — same race condition applies to /es/* unknown paths).
  useEffect(() => {
    const setNoindex = () => {
      document.head.querySelectorAll('meta[name="robots"]').forEach((el) => el.remove());
      const meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      meta.setAttribute('content', 'noindex, nofollow');
      meta.dataset.fwdLocked = '1';
      document.head.appendChild(meta);
    };
    setNoindex();
    return () => {
      document.head.querySelectorAll('meta[name="robots"][data-fwd-locked="1"]').forEach((el) => el.remove());
    };
  }, []);

  return (
  <>
    <EsSEO
      title="Página no encontrada – Fort Worth Dental"
      description="La página que buscas no existe. Vuelve al inicio."
      canonical="/es/404"
      hreflangEn="/"
      noindex
    />
    <section className="py-24 bg-white text-center">
      <div className="container mx-auto px-4 max-w-xl">
        <p className="text-6xl font-bold text-teal-600 mb-3">404</p>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Página no encontrada</h1>
        <p className="text-gray-700 mb-6">
          La página que buscas todavía no está disponible en español. Estamos trabajando en traducir todo el sitio.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/es" className="bg-teal-600 text-white px-6 py-3 rounded-md font-semibold hover:bg-teal-700">
            Ir al Inicio
          </Link>
          <Link to="/es/contacto" className="bg-white border border-teal-600 text-teal-600 px-6 py-3 rounded-md font-semibold hover:bg-teal-50">
            Contáctanos
          </Link>
        </div>
      </div>
    </section>
  </>
  );
};

export default SpanishNotFound;
